// extracted by mini-css-extract-plugin
module.exports = {"page":"LandingPage_page__32Mhf","image":"LandingPage_image__Y-2rP"};